// The message catalogue, assembled from one file per delivery track.
//
// WHY SPLIT. This was a single flat file, and it is the one file every screen
// must touch — so with several screens in flight at once it became the file
// that conflicts on every merge. Splitting by track gives each screen an
// exclusive catalogue and leaves this merger as the only shared surface, which
// changes once per track rather than once per string.
//
// The rationale for a hand-rolled catalogue over an i18n library, and the rule
// that Spanish is never invented here, both live in core.ts and still apply to
// every file merged below.

import { en as recoveryEn } from "./recovery";
import { en as coreEn } from "./core";
import { en as detailsEn } from "./details";
import { en as reviewEn } from "./review";
import { en as desktopEn } from "./desktop";
import { en as apptEn } from "./appointment";
import { en as consentEn } from "./consent";
import { en as guestEn } from "./guest";
import { en as termsEn } from "./terms";

export const en = {
  ...recoveryEn,
  ...coreEn,
  ...detailsEn,
  ...reviewEn,
  ...desktopEn,
  ...apptEn,
  ...consentEn,
  ...guestEn,
  ...termsEn,
} as const;

export type MessageKey = keyof typeof en;

// THE SPANISH HALF IS NOT HERE (rc.12 (b)): it is ./es/spanish.ts, its own
// chunk, loaded only for Spanish readers (i18n/index.ts, `loadSpanish`).

export type Locale = "en" | "es";
export const LOCALES: readonly Locale[] = ["en", "es"];
